/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import BaseCookie from "@/core/js/Cookie/BaseCookie";

export class OwnerIdCookie extends BaseCookie{

	constructor() {
		super('gcowner');
	}

}



